import markBlue from '@/assets/brand/kenchiku-chino/logo-mark-blue.svg';
import typeBlue from '@/assets/brand/kenchiku-chino/logo-type-blue.svg';
import { SERVICE_NAME } from '@/lib/brand';
import styles from './Logo.module.css';

type Variant = 'horizontal' | 'reversed';
type Size = 'header' | 'footer';

type Props = {
  /** horizontal=明背景（藍）/ reversed=藍面・ヒーローの上（白）。 */
  variant?: Variant;
  /** header=ヘッダーの寸法（狭い画面ではサービス名を畳む）/ footer=フッターの寸法。 */
  size?: Size;
  className?: string;
  title?: string;
};

// 建築知能のサービス・ロックアップ：ロゴマーク＋「建築知能」ロゴタイプ＋縦罫＋サービス名。
// 温熱計算・まどりの構造チェックの LP と同じ組み方。白版の画像は持たず、
// reversed では CSS の filter で白にする（ヘッダーの透過 ⇄ 白地の切り替えを滑らかにするため）。
export default function Logo({
  variant = 'horizontal',
  size = 'header',
  className,
  title = `建築知能 ${SERVICE_NAME}`,
}: Props) {
  return (
    <span
      className={[styles.logo, styles[variant], styles[size], className].filter(Boolean).join(' ')}
      role="img"
      aria-label={title}
    >
      <img className={styles.img} src={markBlue} alt="" width={34} height={34} />
      <img className={styles.img} src={typeBlue} alt="" width={167} height={34} />
      <span className={styles.sep} aria-hidden="true" />
      <span className={styles.name} aria-hidden="true">
        {SERVICE_NAME}
      </span>
    </span>
  );
}
